// CardShopComponent.jsx
import React from "react";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import { BASE_URL_API, PRODUCT_BASE_URL_API } from "../Const";
import { CardShopRepository } from "../Repository/CardShopRepository";
import { CardShopStructList } from "../structs/CardShopStructList";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Typography from "@mui/material/Typography";
import { BackButton, BottomMenu } from "./HookUtils";
import { Link } from "react-router-dom";
import Location from "../assets/icons/location.svg";
import EmptyShopCard from "../assets/icons/empty_shopcard.jpg";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AvatarRound from "../assets/icons/avatar_round.svg";
import { safeAdd, safeMultiply } from "./mathUtils";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Zoom2 from "@mui/material/Zoom";

/* =========================
   ✅ Helpers (NO replace on number)
   ========================= */
const n = (v) => {
    const x = Number(v);
    return Number.isFinite(x) ? x : 0;
};
const priceTextFa = (v) => n(v).toLocaleString("fa-IR");

// ✅ unique key for cart row (backward compatible)
// - old products: product.id
// - variant products: product.id + "::" + variant_id
const cartKeyOf = (product) => {
    const pid = product?.id != null ? String(product.id) : "";
    const vid = product?.variant_id != null ? String(product.variant_id) : "";
    return vid ? `${pid}::${vid}` : pid;
};

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export class CardShopComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cardShopList: [],
            totalOrder: 0,
            openSnackbar: false,
            message: "",
            snackbarType: "success",
            userData: null,
            units: props.units_prop || [],
            name: "",
            address: "",
        };
    }

    componentDidMount() {
        this.getCardShop();
        this.getUserData();
    }

    getUserData() {
        fetch(BASE_URL_API + "user", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then(
                (results) => {
                    if (results.code === "200" || results.code === 200) {
                        this.setState({
                            userData: results.data,
                            name: results.data?.name || "",
                            address: results.data?.address || "",
                        });
                    }
                },
                () => {
                    console.log("error");
                }
            );
    }

    /* =========================
       ✅ totals & grouping (variant-safe)
       ========================= */
    getCardShop() {
        const all = CardShopRepository.getAll();
        if (!all) {
            this.setState({ cardShopList: [], totalOrder: 0 });
            return;
        }

        let cardShopList = [];

        all.forEach(function (row) {
            let check = false;

            cardShopList.forEach(function (marketBucket) {
                if (row?.product?.markets?.id === marketBucket?.market?.id) {
                    const unitPrice = n(row.product.price) - n(row.product.del_price);
                    if (unitPrice > 0) {
                        marketBucket.total = safeAdd(
                            marketBucket.total,
                            safeMultiply(n(row.count), unitPrice, 6),
                            6
                        );
                    }
                    marketBucket.productList.push(row);
                    check = true;
                }
            });

            if (!check) {
                let cardShopStructList = new CardShopStructList();
                cardShopStructList.market = row.product.markets;
                cardShopStructList.total = 0;
                cardShopStructList.productList = [];

                const unitPrice = n(row.product.price) - n(row.product.del_price);
                if (unitPrice > 0) {
                    cardShopStructList.total = safeAdd(
                        cardShopStructList.total,
                        safeMultiply(n(row.count), unitPrice, 6),
                        6
                    );
                }

                cardShopStructList.productList.push(row);
                cardShopList.push(cardShopStructList);
            }
        });

        // total of all markets
        let sum = 0;
        cardShopList.forEach(function (m) {
            sum = safeAdd(sum, n(m.total), 6);
        });

        this.setState({
            cardShopList,
            totalOrder: Math.floor(sum),
        });
    }

    render() {
        const handleCloseSnackbar = () => {
            this.setState({ openSnackbar: false });
        };

        const MAX_LENGTH = 50;

        const onPaymentCLicked = () => {
            const list = CardShopRepository.getAll();

            if (!this.state.name) {
                this.setState({
                    openSnackbar: true,
                    message: "ابتدا نام و نام خانوادگی را تکمیل کنید!",
                    snackbarType: "error",
                });
                return;
            }

            if (!this.state.address) {
                this.setState({
                    openSnackbar: true,
                    message: "ابتدا آدرس خودرا از منوی پروفایل تکمیل کنید!",
                    snackbarType: "error",
                });
                return;
            }

            if (list !== null && list.length) {
                // ✅ backward compatible server payload:
                // keep sending product.id (your backend expects this)
                // If later you want variant-aware order, add another field.
                let products = list[0].product.id;
                let counts = list[0].count;

                if (list.length > 1) {
                    for (let i = 1; i < list.length; i++) {
                        products += "," + list[i].product.id;
                        counts += "," + list[i].count;
                    }
                }

                fetch(BASE_URL_API + "order", {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        products: products.toString(),
                        counts: counts.toString(),
                        user_agent: "pwa",
                    }),
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.code === 200) {
                            this.setState({
                                openSnackbar: true,
                                message: "در حال انتقال به درگاه پرداخت...",
                                snackbarType: "success",
                            });
                            redirectToSepehr(result);
                        } else {
                            this.setState({
                                openSnackbar: true,
                                message: result.message,
                                snackbarType: "error",
                            });
                        }
                    });
            }
        };

        const redirectToSepehr = (data) => {
            const form = document.createElement("form");
            form.method = "POST";
            form.action = data.redirect_url;

            const fields = {
                TerminalID: data.merchant_id,
                token: data.token,
                getMethod: "1",
            };

            Object.keys(fields).forEach((key) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = fields[key];
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();
        };

        return (
            <React.Fragment>
                <AppBar
                    style={{
                        background: "rgba(238,238,238,0.3)",
                        overflow: "auto",
                        display: "flex",
                    }}
                >
                    <ToolbarMui>
                        <ShoppingBasketOutlinedIcon style={{ color: "black" }} />
                        <ListItemText align="center">
                            <strong
                                style={{
                                    fontSize: 18,
                                    overflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    color: "black",
                                }}
                            >
                                {"سبد خرید"}
                            </strong>
                        </ListItemText>
                        <BackButton />
                    </ToolbarMui>
                </AppBar>

                {this.state.userData !== null ? (
                    <div
                        style={{ background: "#f5f5f5", marginTop: 65, padding: 32 }}
                        alignItems="center"
                        justifyContent="center"
                        align="center"
                    >
                        <div style={{ display: "flex" }}>
                            <img
                                style={{ width: 28, height: 28, marginTop: 8 }}
                                alt="avatar2"
                                src={AvatarRound}
                            />

                            <Typography
                                style={{
                                    overflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    color: "black",
                                    fontWeight: "bold",
                                    flex: 12,
                                }}
                                align="right"
                            >
                                <p
                                    style={{
                                        fontSize: 14,
                                        overflow: "ellipsis",
                                        paddingRight: 8,
                                        color: "black",
                                    }}
                                >
                                    {"نام و نام خانوادگی: ‌" + (this.state.userData?.name || "")}
                                </p>
                            </Typography>

                            <IconButton component={Link} to={"/profile"} size="large">
                                <BorderColorIcon style={{ color: "black" }} />
                            </IconButton>
                        </div>

                        <div style={{ display: "flex" }}>
                            <img
                                style={{ width: 24, height: 24, marginTop: 8 }}
                                alt="avatar2"
                                src={Location}
                            />

                            <Typography
                                style={{
                                    overflow: "ellipsis",
                                    whiteSpace: "pre-line",
                                    wordWrap: "break-word",
                                    color: "black",
                                    fontWeight: "bold",
                                    flex: 12,
                                }}
                                align="right"
                            >
                                <p
                                    style={{
                                        fontSize: 14,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        paddingRight: 8,
                                        color: "black",
                                    }}
                                >
                                    {"ارسال به: ‌" + (this.state.userData?.address || "")}
                                </p>
                            </Typography>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {this.state.cardShopList === null ||
                this.state.cardShopList.length === 0 ? (
                    <div align="center">
                        <img style={{ width: "20%" }} alt="avatar2" src={EmptyShopCard} />
                    </div>
                ) : (
                    ""
                )}

                <List>
                    {this.state.cardShopList.map((marketBucket, idxMarket) => (
                        <ListItem
                            key={marketBucket?.market?.id || idxMarket}
                            style={{
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div style={{ maxWidth: 500 }}>
                                <Paper>
                                    <ListItemText style={{ align: "right" }}>
                                        <Grid container>
                                            <Grid item xs={6}>
                                                <p
                                                    style={{
                                                        marginRight: 12,
                                                        overflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        color: "green",
                                                        fontWeight: "bold",
                                                    }}
                                                    align="right"
                                                >
                                                    {marketBucket.market?.name}
                                                </p>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <p
                                                    style={{
                                                        textOverflow: "ellipsis",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        color: "gray",
                                                        fontSize: 12,
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {`هزینه ارسال: ${"پس کرایه"}`}
                                                </p>
                                            </Grid>

                                            {(marketBucket.productList || []).map((row, idxRow) => {
                                                const product = row?.product || {};
                                                const key = cartKeyOf(product) || `${idxMarket}-${idxRow}`;

                                                const unitPrice = n(product.price) - n(product.del_price);
                                                const qty = n(row?.count);
                                                const lineTotal =
                                                    unitPrice > 0 ? safeMultiply(qty, unitPrice, 6) : 0;

                                                const title = product?.title || "";
                                                const showTitle =
                                                    title.length > MAX_LENGTH
                                                        ? `${title.substring(0, MAX_LENGTH)}...`
                                                        : title;

                                                const unitsCache =
                                                    JSON.parse(
                                                        localStorage.getItem("productUnitsCache")
                                                    ) || [];
                                                const selectedUnit = unitsCache.find(
                                                    (u) => u.id === product.unit_id
                                                );
                                                const dataType = selectedUnit?.data_type;

                                                return (
                                                    <React.Fragment key={key}>
                                                        <Grid item xs={2}>
                                                            <Paper
                                                                style={{
                                                                    width: 45,
                                                                    height: 45,
                                                                    marginRight: 15,
                                                                    marginBottom: 15,
                                                                    align: "center",
                                                                    backgroundPosition: "center",
                                                                }}
                                                            >
                                                                <img
                                                                    style={{
                                                                        width: 45,
                                                                        height: 45,
                                                                        objectFit: "cover",
                                                                    }}
                                                                    alt=""
                                                                    src={
                                                                        product?.pictures?.length > 0
                                                                            ? PRODUCT_BASE_URL_API +
                                                                            product.pictures[0].url
                                                                            : "hamekara-logo.png"
                                                                    }
                                                                />
                                                            </Paper>

                                                            {/* ✅ FIXED: no replace() */}
                                                            <p
                                                                style={{
                                                                    overflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    color: "gray",
                                                                    marginRight: 15,
                                                                    fontSize: 12,
                                                                }}
                                                            >
                                                                {"قیمت: " + priceTextFa(product.price) + " تومان"}
                                                            </p>

                                                            {/* ✅ show variant title small if exists */}
                                                            {product?.variant && (
                                                                <p
                                                                    style={{
                                                                        overflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        color: "#666",
                                                                        marginRight: 15,
                                                                        fontSize: 11,
                                                                    }}
                                                                >
                                                                    {product?.variant?.title
                                                                        ? `تنوع: ${product.variant.title}`
                                                                        : ""}
                                                                </p>
                                                            )}
                                                        </Grid>

                                                        <Grid item xs={4}>
                                                            <p
                                                                style={{
                                                                    overflow: "ellipsis",
                                                                    whiteSpace: "pre-line",
                                                                    wordWrap: "break-word",
                                                                    fontSize: 12,
                                                                }}
                                                                align="center"
                                                            >
                                                                {showTitle}
                                                            </p>
                                                        </Grid>

                                                        <Grid item xs={2}>
                                                            <p
                                                                style={{
                                                                    overflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    fontSize: 12,
                                                                }}
                                                                align="center"
                                                            >
                                                                {selectedUnit
                                                                    ? `${selectedUnit.unit_type} ${row.count} ${selectedUnit.name}`
                                                                    : `${row.count}`}
                                                            </p>
                                                        </Grid>

                                                        {n(product.price) > 0 ? (
                                                            <Grid item xs={4}>
                                                                <p
                                                                    style={{
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        fontSize: 12,
                                                                    }}
                                                                    align="center"
                                                                >
                                                                    {"مجموع: " +
                                                                        priceTextFa(Math.floor(n(lineTotal))) +
                                                                        " تومان"}
                                                                </p>
                                                            </Grid>
                                                        ) : (
                                                            <Grid item xs={3}>
                                                                <p
                                                                    style={{
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        fontSize: 12,
                                                                    }}
                                                                    align="center"
                                                                >
                                                                    {" تماس بگیرید "}
                                                                </p>
                                                            </Grid>
                                                        )}

                                                        {/* Controls */}
                                                        <Grid
                                                            item
                                                            xs={20}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "8px",
                                                                marginTop: "8px",
                                                            }}
                                                        >
                                                            {/* Decrease */}
                                                            <IconButton
                                                                color="inherit"
                                                                aria-label="decrease"
                                                                edge="end"
                                                                onClick={() => {
                                                                    if (!row?.product) return;

                                                                    const numResult = (
                                                                        parseFloat(row.count) - 1
                                                                    ).toFixed(3);
                                                                    const result = parseFloat(numResult);
                                                                    const newCount = Math.max(0, result);

                                                                    // ✅ variant-safe remove:
                                                                    if (newCount === 0) {
                                                                        // remove by key (productId + variantId)
                                                                        CardShopRepository.removeItemByKey(key);

                                                                        // update UI list
                                                                        this.setState((prev) => {
                                                                            const updatedList = (prev.cardShopList || [])
                                                                                .map((m) => ({
                                                                                    ...m,
                                                                                    productList: (m.productList || []).filter(
                                                                                        (p) =>
                                                                                            cartKeyOf(p?.product) !== key
                                                                                    ),
                                                                                }))
                                                                                .filter((m) => (m.productList || []).length > 0);

                                                                            // recompute total
                                                                            const totalOrder = updatedList.reduce(
                                                                                (sumMarket, m) => {
                                                                                    const mt = (m.productList || []).reduce(
                                                                                        (sumProduct, p) => {
                                                                                            const pr =
                                                                                                n(p?.product?.price) -
                                                                                                n(p?.product?.del_price);
                                                                                            const q = n(p?.count);
                                                                                            const lt = safeMultiply(
                                                                                                q,
                                                                                                pr > 0 ? pr : 0,
                                                                                                6
                                                                                            );
                                                                                            return safeAdd(sumProduct, lt, 6);
                                                                                        },
                                                                                        0
                                                                                    );
                                                                                    return safeAdd(sumMarket, mt, 6);
                                                                                },
                                                                                0
                                                                            );

                                                                            return {
                                                                                cardShopList: updatedList,
                                                                                totalOrder: Math.floor(n(totalOrder)),
                                                                            };
                                                                        });

                                                                        return;
                                                                    }

                                                                    // update repo count
                                                                    CardShopRepository.updateCountByKey(key, row.product, newCount);
                                                                    row.count = newCount;

                                                                    // recompute total
                                                                    const totalOrder = this.state.cardShopList.reduce(
                                                                        (sumMarket, m) => {
                                                                            const mt = (m.productList || []).reduce(
                                                                                (sumProduct, p) => {
                                                                                    const pr =
                                                                                        n(p?.product?.price) -
                                                                                        n(p?.product?.del_price);
                                                                                    const q = n(p?.count);
                                                                                    const lt = safeMultiply(
                                                                                        q,
                                                                                        pr > 0 ? pr : 0,
                                                                                        6
                                                                                    );
                                                                                    return safeAdd(sumProduct, lt, 6);
                                                                                },
                                                                                0
                                                                            );
                                                                            return safeAdd(sumMarket, mt, 6);
                                                                        },
                                                                        0
                                                                    );

                                                                    this.setState({ totalOrder: Math.floor(n(totalOrder)) });
                                                                }}
                                                                sx={{
                                                                    ...(this.state.open && { display: "none" }),
                                                                    width: 48,
                                                                    height: 48,
                                                                }}
                                                                size="large"
                                                            >
                                                                <RemoveCircleOutlineIcon
                                                                    sx={{ fontSize: 32, color: "red" }}
                                                                />
                                                            </IconButton>

                                                            {/* Input */}
                                                            <input
                                                                type="text"
                                                                value={row.count}
                                                                style={{
                                                                    width: 100,
                                                                    direction: "rtl",
                                                                    textAlign: "right",
                                                                    padding: 6,
                                                                    borderRadius: 8,
                                                                    border: "1px solid #ccc",
                                                                    fontSize: 14,
                                                                }}
                                                                onChange={(e) => {
                                                                    let val = e.target.value;
                                                                    if (!/^\d*\.?\d*$/.test(val)) return;

                                                                    // int/float rules based on unit cache
                                                                    if (dataType === "int" && val.includes(".")) {
                                                                        val = val.split(".")[0];
                                                                    }

                                                                    if (dataType === "float") {
                                                                        if (val.includes(".")) {
                                                                            const [intPart, decPart] = val.split(".");
                                                                            if ((decPart || "").length > 3) return;
                                                                        }
                                                                        row.count = val;
                                                                        this.setState({});
                                                                        return;
                                                                    }

                                                                    if (val === "" || val === ".") {
                                                                        row.count = val;
                                                                        this.setState({});
                                                                        return;
                                                                    }

                                                                    let numVal = parseFloat(val);
                                                                    if (isNaN(numVal) || numVal < 0) {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "تعداد معتبر وارد کنید!",
                                                                            snackbarType: "error",
                                                                        });
                                                                        return;
                                                                    }

                                                                    const maxVal = n(row.product.step);
                                                                    if (numVal > maxVal) {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "موجودی کالا کافی نیست!",
                                                                            snackbarType: "error",
                                                                        });
                                                                        numVal = maxVal;
                                                                    }

                                                                    if (dataType === "float") {
                                                                        numVal = parseFloat(numVal.toFixed(3));
                                                                    }

                                                                    row.count = numVal;
                                                                    this.setState({});

                                                                    CardShopRepository.updateCountByKey(key, row.product, numVal);

                                                                    const totalOrder = this.state.cardShopList.reduce(
                                                                        (sumMarket, m) => {
                                                                            const mt = (m.productList || []).reduce(
                                                                                (sumProduct, p) => {
                                                                                    const pr =
                                                                                        n(p?.product?.price) -
                                                                                        n(p?.product?.del_price);
                                                                                    const q = n(p?.count);
                                                                                    const lt = safeMultiply(
                                                                                        q,
                                                                                        pr > 0 ? pr : 0,
                                                                                        6
                                                                                    );
                                                                                    return safeAdd(sumProduct, lt, 6);
                                                                                },
                                                                                0
                                                                            );
                                                                            return safeAdd(sumMarket, mt, 6);
                                                                        },
                                                                        0
                                                                    );

                                                                    this.setState({ totalOrder: Math.floor(n(totalOrder)) });
                                                                }}
                                                                onBlur={() => {
                                                                    if (row.count === "" || row.count === ".") return;

                                                                    let val = parseFloat(row.count);
                                                                    if (isNaN(val) || val < 0) {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "تعداد معتبر وارد کنید!",
                                                                            snackbarType: "error",
                                                                        });
                                                                        row.count = "";
                                                                        return;
                                                                    }

                                                                    if (dataType === "int") {
                                                                        val = Math.floor(val);
                                                                    }
                                                                    if (dataType === "float") {
                                                                        val = parseFloat(val.toFixed(3));
                                                                    }

                                                                    const maxVal = n(row.product.step);
                                                                    if (val > maxVal) {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "موجودی کالا کافی نیست!",
                                                                            snackbarType: "error",
                                                                        });
                                                                        val = maxVal;
                                                                    }

                                                                    row.count = val;
                                                                    this.setState({});

                                                                    CardShopRepository.updateCountByKey(key, row.product, val);

                                                                    const totalOrder = this.state.cardShopList.reduce(
                                                                        (sumMarket, m) => {
                                                                            const mt = (m.productList || []).reduce(
                                                                                (sumProduct, p) => {
                                                                                    const pr =
                                                                                        n(p?.product?.price) -
                                                                                        n(p?.product?.del_price);
                                                                                    const q = n(p?.count);
                                                                                    const lt = safeMultiply(
                                                                                        q,
                                                                                        pr > 0 ? pr : 0,
                                                                                        6
                                                                                    );
                                                                                    return safeAdd(sumProduct, lt, 6);
                                                                                },
                                                                                0
                                                                            );
                                                                            return safeAdd(sumMarket, mt, 6);
                                                                        },
                                                                        0
                                                                    );

                                                                    this.setState({ totalOrder: Math.floor(n(totalOrder)) });

                                                                    if (val === 0) {
                                                                        setTimeout(() => {
                                                                            CardShopRepository.removeItemByKey(key);
                                                                            this.getCardShop();
                                                                        }, 100);
                                                                    }
                                                                }}
                                                            />

                                                            {/* Increase */}
                                                            <IconButton
                                                                color="inherit"
                                                                aria-label="increase"
                                                                edge="end"
                                                                onClick={() => {
                                                                    let currentCount = n(row.count);
                                                                    const maxCount = n(row.product.step);

                                                                    if (currentCount < maxCount) {
                                                                        if (n(row.product.price) > 0) {
                                                                            currentCount = parseFloat(
                                                                                (currentCount + 1).toFixed(3)
                                                                            );
                                                                            if (currentCount > maxCount)
                                                                                currentCount = maxCount;

                                                                            CardShopRepository.updateCountByKey(
                                                                                key,
                                                                                row.product,
                                                                                currentCount
                                                                            );
                                                                            row.count = currentCount;

                                                                            const totalOrder = this.state.cardShopList.reduce(
                                                                                (sumMarket, m) => {
                                                                                    const mt = (m.productList || []).reduce(
                                                                                        (sumProduct, p) => {
                                                                                            const pr =
                                                                                                n(p?.product?.price) -
                                                                                                n(p?.product?.del_price);
                                                                                            const q = n(p?.count);
                                                                                            const lt = safeMultiply(
                                                                                                q,
                                                                                                pr > 0 ? pr : 0,
                                                                                                6
                                                                                            );
                                                                                            return safeAdd(sumProduct, lt, 6);
                                                                                        },
                                                                                        0
                                                                                    );
                                                                                    return safeAdd(sumMarket, mt, 6);
                                                                                },
                                                                                0
                                                                            );

                                                                            this.setState({
                                                                                totalOrder: Math.floor(n(totalOrder)),
                                                                            });
                                                                        } else {
                                                                            this.setState({
                                                                                openSnackbar: true,
                                                                                message: "جهت خرید کالا تماس بگیرید.",
                                                                                snackbarType: "error",
                                                                            });
                                                                        }
                                                                    } else {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "موجودی کالا به اتمام رسیده!",
                                                                            snackbarType: "error",
                                                                        });
                                                                    }
                                                                }}
                                                                size="large"
                                                            >
                                                                <AddCircleIcon
                                                                    sx={{ fontSize: 32, color: "green" }}
                                                                />
                                                            </IconButton>
                                                        </Grid>
                                                    </React.Fragment>
                                                );
                                            })}

                                            {/* Market total footer */}
                                            <Grid xs={12} style={{ width: "100%", background: "green" }}>
                                                <p
                                                    style={{
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        paddingRight: 12,
                                                        fontSize: 12,
                                                        color: "white",
                                                    }}
                                                    align="right"
                                                >
                                                    {"مجموع: " +
                                                        priceTextFa(Math.floor(n(marketBucket.total))) +
                                                        " تومان"}
                                                </p>
                                            </Grid>
                                        </Grid>
                                    </ListItemText>
                                </Paper>
                            </div>
                        </ListItem>
                    ))}
                </List>

                {this.state.cardShopList.length > 0 ? (
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            direction: "rtl",
                            paddingBottom: 90,
                        }}
                    >
                        <Tooltip
                            title="⚠️ فیلترشکن خود را قبل از اتصال به درگاه خاموش کنید."
                            placement="top"
                            arrow
                            open={true}
                            TransitionComponent={Zoom2}
                        >
                            <Button
                                onClick={() => onPaymentCLicked()}
                                variant="contained"
                                style={{
                                    color: "white",
                                    margin: "40px 0 10px 0",
                                    background: "green",
                                    padding: "10px 30px",
                                    fontSize: "16px",
                                    borderRadius: "8px",
                                }}
                            >
                                {`تکمیل سفارش (${priceTextFa(Math.floor(
                                    n(this.state.totalOrder) +
                                    this.state.cardShopList.reduce(
                                        (sum) => sum /* + shipping */,
                                        0
                                    )
                                ))} تومان)`}
                            </Button>
                        </Tooltip>
                    </div>
                ) : null}

                <Snackbar
                    open={this.state.openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                >
                    <Alert
                        onClose={handleCloseSnackbar}
                        severity={this.state.snackbarType}
                        sx={{ width: "100%" }}
                    >
                        {this.state.message}
                    </Alert>
                </Snackbar>

                <BottomMenu />
            </React.Fragment>
        );
    }
}
